import type { FC } from "react";

import { ColoredLabel } from "widgets";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { getEventTagIntent, getTagIntentColor } from "@/app-utils/events.js";
import type { PlaybookEvent } from "@/graphql.js";

const PlaybookEventStatusCell: FC<IAgGridCellProps> = (props) => {
  const playbookEvent = props.data as PlaybookEvent;

  if (playbookEvent == null) {
    return null;
  }

  return (
    <TableCell>
      <ColoredLabel color={getTagIntentColor(getEventTagIntent(playbookEvent.status))} label={playbookEvent.status} />
    </TableCell>
  );
};

export default PlaybookEventStatusCell;
